



import { BaseEntityResponse } from '@m4u-angular/base/entities/BaseEntities';
import { BaseEntitiesResponse } from '@m4u-angular/base/entities/BaseEntities';
import { BaseDataResponse } from '@m4u-angular/base/entities/BaseEntities';
import { BaseResponse } from '@m4u-angular/base/entities/BaseEntities';
import { GenericListEntity } from '@m4u-angular/base/entities/BaseEntities';
import { DataGroupInfo } from '@m4u-angular/base/entities/BaseEntities';
import { BaseEndpoint } from '@m4u-angular/base/endpoint/BaseEndpoint';
import { BaseEndpointCRUD } from '@m4u-angular/base/endpoint/BaseEndpointCRUD';
import { DataLoadOptions } from '@m4u-angular/base/datalayer/DataLoadOptions';
import { APIGatewayService } from '@m4u-angular/core/gateway/APIGateway.service';
import { EnumRequestProgressTracking } from '@m4u-angular/core/framework/sysenums.enum';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Registration } from './../entities/registration.entity';
import { PaymentRequestParams } from './../params/paymentrequest.param';
@Injectable()
export class RegistrationEndpoint extends BaseEndpointCRUD<Registration>
{
    constructor(api: APIGatewayService) {super("Registration", api);}
	

    public SendPaymentRequest(oPaymentRequest: PaymentRequestParams) : Observable<BaseDataResponse<string>>
	{
		return this.api.ExecutePostAction(this.ControllerName, 'SendPaymentRequest', oPaymentRequest,  undefined );
    }

    public ConfirmPaymentRequest(oPaymentRequest: PaymentRequestParams) : Observable<BaseEntityResponse<Registration>>
	{
		return this.api.ExecutePostAction(this.ControllerName, 'ConfirmPaymentRequest', oPaymentRequest,  undefined );
    }   
}
